module.exports = __webpack_public_path__ + "static/img/openFlower2.576417f7.jpeg";